import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

@Component({
	selector: 'app-apps',
	templateUrl: './apps.component.html',
	styleUrls: ['./apps.component.css']
})
export class AppsComponent implements OnInit {

	admPageObj:any = "curr";

	logi_user:any;

	appData:any = [];

	frm : FormGroup;

	constructor(
		private http: HttpClient,
		private fb: FormBuilder,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = fb.group({
			app_ltxt: ['', [Validators.required]],
			app_bike_price: ['0', [Validators.maxLength(5)]]
		});
	}

	ngOnInit() {
		this.getAppData();
	}

	async getAppData() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/app.data.php', formData).subscribe((response) => {
			this.appData = response['data'];

			this.frm.get('app_ltxt').setValue(response['data']['app_title']);
			this.frm.get('app_bike_price').setValue(response['data']['bike_price']);
		});
	}

	async appForm() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);
		formData.append("app_ltxt", this.frm.get('app_ltxt').value);
		formData.append("app_bike_price", this.frm.get('app_bike_price').value);

		this.func.prcLoading();

		this.http.post(this.env.API_URL + 'api/app.process.php', formData).subscribe((response) => {
			this.func.closeLoading();
			this.getAppData();
		});
	}

}
